import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";

const PaymentApi = {
  getPaymentLog: (params) => {
    const url = "transaction";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getPayment: () => {
    const url = "payment-method";
    return axiosClient.get(url);
  },

  updatePayment: (params) => {
    const url = "payment-method";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },

  deleteNote: (params) => {
    const url = "payment-method";
    return axiosClient.delete(url, { params });
  },
};

export default PaymentApi;
